<template>
  <v-container grid-list-md>
    <div class="pageTitle">タイムシート管理</div>
    <v-expansion-panel v-model="panel" expand style="margin: 10px 0px">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div class="title">表示条件</div>
        </template>
        <v-card>
          <v-card-text>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">年月</v-flex>
              <v-flex md2>
                <v-select :items="years" v-model="year" suffix="年" />
              </v-flex>
              <v-flex md1>
                <v-select :items="months" v-model="month" suffix="月" />
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">勤怠種別</v-flex>
              <v-flex md10>
                <v-radio-group v-model="workType" row>
                  <v-radio
                    :label="workType"
                    :value="workType"
                    v-for="(workType, i) in workTypes"
                    :key="i"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">チーム</v-flex>
              <v-flex md2 v-for="(team, i) in teams" :key="i">
                <v-checkbox
                  v-model="selectedTeams"
                  :label="team"
                  :value="team"
                  :disabled="CanI('ManageMyTeam')"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">スタッフ</v-flex>
              <v-flex md8>
                <v-autocomplete
                  v-model="selectedStaffs"
                  :items="staffs"
                  chips
                  item-text="name"
                  item-value="name"
                  multiple
                  :menu-props="{ auto: true, overflowY: true }"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md2>
                <v-btn @click="clearSelectedStaffs">
                  <v-icon>backspace</v-icon>クリア
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">フリーワード *</v-flex>
              <v-flex md4>
                <v-text-field v-model="search"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-dialog v-model="dialog" persistent max-width="80%">
      <read-timecard
        @closeDialog="dialog = false"
        v-model="selectedTimecard"
        v-if="dialog"
      />
    </v-dialog>

    <v-layout style="height: 400px; width: 100%">
      <div class="table-container scroll-bar">
        <v-data-table
          v-if="workType == '一般'"
          :headers="headers"
          :items="filteredItems"
          class="elevation-1"
          :search="search"
          :pagination.sync="pagination"
          rows-per-page-text="表示行"
          :rows-per-page-items="rowsPerPageItems"
          style="width: 1200px"
          :fixed-header="true"
        >
          <template slot="items" slot-scope="props">
            <tr @click="toTimesheet(props.item)">
              <td class="text-xs-left">{{ props.item.staff_id }}</td>
              <td class="text-xs-left">{{ props.item.user_name }}</td>
              <td class="text-xs-left">{{ props.item.status }}</td>
              <td>{{ getTime(props.item.counts.time.work) }}</td>
              <td>{{ getTime(props.item.counts.time.lateNight) }}</td>
              <td>{{ getTime(props.item.counts.time.paidDayOff) }}</td>
              <td>{{ getTime(props.item.counts.time.noPaidDayOff) }}</td>
              <td>{{ getTime(props.item.counts.time.monthly_predefined) }}</td>
              <td>
                {{
                  props.item.counts.time.diffrence_monthly_predefined_and_work >
                  0
                    ? getTime(0)
                    : getTime(
                        -1 *
                          props.item.counts.time
                            .diffrence_monthly_predefined_and_work
                      )
                }}
              </td>
              <td>
                {{
                  props.item.counts.time.diffrence_monthly_predefined_and_work >
                  0
                    ? getTime(
                        props.item.counts.time
                          .diffrence_monthly_predefined_and_work
                      )
                    : getTime(0)
                }}
              </td>
              <td>{{ getTime(props.item.counts.time.holidayWork) }}</td>
              <td>{{ getTime(props.item.counts.time.holidayLateNight) }}</td>
              <td>{{ props.item.counts.date.homeWorkDay }}</td>
            </tr>
          </template>
          <template slot="pageText" slot-scope="props"
            >{{ props.itemsLength }} 件中 {{ props.pageStart }} -
            {{ props.pageStop }} 件表示</template
          >
        </v-data-table>
        <v-data-table
          v-if="workType == '時給' || workType == 'アルバイト'"
          :headers="headersForHourly"
          :items="filteredItems"
          class="elevation-1 sticky_table"
          :search="search"
          :pagination.sync="pagination"
          rows-per-page-text="表示行"
          :rows-per-page-items="rowsPerPageItems"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="{ sticky: true, 'column-fixed': header.text == '日' }"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr @click="toTimesheet(props.item)">
              <td class="text-xs-left">{{ props.item.staff_id }}</td>
              <td class="text-xs-left">{{ props.item.user_name }}</td>
              <td class="text-xs-left">{{ props.item.status }}</td>
              <td>
                {{
                  getTime(
                    props.item.counts.time.work +
                      props.item.counts.time.holidayWork
                  )
                }}
              </td>
              <td>{{ getTime(props.item.counts.time.paidDayOff) }}</td>
              <td>
                {{
                  getTime(
                    props.item.counts.time.work +
                      props.item.counts.time.holidayWork +
                      props.item.counts.time.paidDayOff -
                      props.item.counts.time.overtime
                  )
                }}
              </td>
              <td>{{ getTime(props.item.counts.time.overtime) }}</td>
              <td>
                {{
                  getTime(
                    props.item.counts.time.holidayLateNight +
                      props.item.counts.time.lateNight
                  )
                }}
              </td>
              <td>{{ props.item.counts.date.homeWorkDay }}</td>
            </tr>
          </template>
          <template slot="pageText" slot-scope="props"
            >{{ props.itemsLength }} 件中 {{ props.pageStart }} -
            {{ props.pageStop }} 件表示</template
          >
        </v-data-table>
      </div>
    </v-layout>
    <v-btn color="green" class="white--text" @click="scrollToTop">
      <v-icon color="white">arrow_upward</v-icon>トップへ戻る
    </v-btn>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import ReadTimecard from "@/components/ManageAttendance/readTimecard.vue";
import { mapGetters, mapState, mapActions } from "vuex";
import { getMoment, unixtimeToFormattedLargeTime } from "@/utils/datetime.js";
import { teamsArray } from "@/master/users.js";
import { workTypesArray } from "@/master/users.js";

export default {
  components: {
    ReadTimecard,
  },
  data() {
    return {
      dbRef: db.collection("timesheets"),
      dialog: false,
      year: 2020,
      month: 1,
      dates: [],
      timecards: [],
      items: [],
      years: [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      teams: teamsArray,
      selectedTeams: [],
      selectedTimecard: {},
      panel:[true],
      selectedStaffs: [],
      staffs: [],
      headers: [
        { text: "社員番号 ​*​", value: "staff_id", sortable: false },
        { text: "名前​ ​*", value: "user_name", sortable: false },
        { text: "ステータス​ ​*", value: "status", sortable: false },
        { text: "平日総労働​", sortable: false },
        { text: "平日深夜勤務​", sortable: false },
        { text: "有給​", sortable: false },
        { text: "無休", sortable: false },
        { text: "所定", sortable: false },
        { text: "超過", sortable: false },
        { text: "不足​​", sortable: false },
        { text: "休日総労働", sortable: false },
        { text: "うち深夜勤務", sortable: false },
        { text: "在宅日", sortable: false },
      ],
      headersForHourly: [
        { text: "社員番号 ​*", value: "staff_id", sortable: false },
        { text: "名前​ ​*", value: "user_name", sortable: false },
        { text: "ステータス​ ​*", value: "status", sortable: false },
        { text: "総実働​", sortable: false },
        { text: "有給​", sortable: false },
        { text: "​​普通", sortable: false },
        { text: "超過", sortable: false },
        { text: "深夜​​", sortable: false },
        { text: "在宅日", sortable: false },
      ],
      workType: "一般",
      workTypes: workTypesArray,
      pagination: {
        rowsPerPage: 50,
      },
      rowsPerPageItems: [25, 50, 100],
      search: "",
    };
  },
  created() {
    const today = getMoment()();
    this.month = today.month() + 1;
    this.year = today.year();
    this.reloadItems();
  },
  mounted() {
    this.fixHeaders();
    this.reloadStaffs();
  },
  computed: {
    month_id() {
      return String(this.year) + "-" + ("0" + this.month).slice(-2);
    },
    filteredItems() {
      return this.items.filter((item) => {
        if (this.CanI("ManageMyTeam")) {
          this.selectedTeams = [this.profile.team_name];
        }
        return (
          item.counts &&
          item.counts.time &&
          this.selectedTeams.includes(item.team_name) &&
          item.work_type == this.workType &&
          (this.selectedStaffs.length == 0 ||
            this.selectedStaffs.includes(item.user_name)) 
        );
      }, this);
    },
    ...mapGetters("auth", ["CanI", "isLoggedIn", "user", "profile"]),
    ...mapState("auth", ["authorities"]),
  },
  watch: {
    month() {
      this.reloadItems();
    },
  },
  methods: {
    clearSelectedStaffs() {
      this.selectedStaffs = [];
    },
    async reloadStaffs() {
      this.changeLoadingState(true);
      this.staffs = [];
      try {
        const staffs = await db.collection("users").get();
        staffs.forEach((doc) => {
          this.staffs.push({ ...doc.data(), id: doc.id });
        });
      } finally {
        this.changeLoadingState(false);
      }
    },
    scrollToTop() {
      document.querySelector(".v-datatable tbody tr").scrollIntoView(false);
    },
    fixHeaders() {
      var elms = document.getElementsByClassName("v-table__overflow");
      elms[0].style.overflow = "visible";
    },
    async reloadItems() {
      this.changeLoadingState(true);
      const items = await this.dbRef
        .where("month_id", "==", this.month_id)
        .where("version", ">=", 2)
        .get();
      this.items = [];
      items.forEach((doc) => {
        const item = doc.data();
        this.items.push({ ...item, id: doc.id });
      });
      this.changeLoadingState(false);
    },
    prvMonth() {
      this.month = this.month - 1;
    },
    nextMonth() {
      this.month = this.month + 1;
    },
    getTime(unixtime) {
      return unixtimeToFormattedLargeTime(unixtime);
    },
    toTimesheet(item) {
      const route = this.$router.resolve({
        name: "home",
        params: { user_id: item.user_id },
        query: { year: this.year, month: this.month },
      });
      window.open(route.href, "_blank");
    },

    ...mapActions("app", ["changeLoadingState"]),
  },
};
</script>

<style lang="css" scoped>
div.pageTitle {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
div.yearMonth {
  display: inline-block;
  font-size: 20px;
  /* color: #ddd; */
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
td.holiday {
  color: #f44336;
}
td.saturday {
  color: #2196f3;
}
td.text-smaller {
  font-size: 0.8em;
}

.scroll-bar {
  overflow: auto;
}
.scroll-bar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroll-bar::-webkit-scrollbar-thumb {
  background: gray;
}
.v-icon {
  margin-right: 0.3em;
}
.v-datatable th.sticky {
  background-color: white !important;
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  top: 0;
}
</style>